import type { ApprovedOfferViewModel } from './approvedOffer';
import type { ClientOfferDTO } from './clientOffer.types';
import { getVatDocumentLabel, getVatSettlementLabel, type VatSettlementMode } from './vatLabels';

/** One projection of approved prices and decisions for PDF and saved public offers. */
export function buildApprovedOfferDocument(offer: ApprovedOfferViewModel, vatMode: VatSettlementMode) {
  return {
    workNet: offer.pricing.workNet,
    materialNet: offer.pricing.materialNet,
    netTotal: offer.pricing.netTotal,
    vatPercent: offer.pricing.vatRate * 100,
    vatLabel: getVatDocumentLabel(vatMode),
    vatAmount: offer.pricing.vatAmount,
    grossTotal: offer.pricing.grossTotal,
    settlementLabel: getVatSettlementLabel(vatMode),
    materialMode: offer.materialMode,
    materialLines: offer.materialLines.map(({ label, quantityLabel, clientPrice }) => ({ label, quantityLabel, clientPrice })),
    items: offer.items.map((item, index) => ({
      id: item.id || `offer-item-${String(index + 1)}`, name: item.label,
      quantity: item.quantity, unit: item.unit, unitPrice: item.unitRateNetto, total: item.totalNetto,
    })),
    includedScopeLabels: [...offer.includedScopeLabels],
    excludedScopeLabels: [...offer.excludedScopeLabels],
    unresolvedScopeLabels: [...offer.unresolvedScopeLabels],
  } satisfies Partial<ClientOfferDTO>;
}

export type ApprovedOfferDocument = ReturnType<typeof buildApprovedOfferDocument>;
